import * as React from 'react';
import OtherEventForm from './OtherEventForm';
import RhRunTable from './RhRunTable';
import { EventGroupRaceCarnumSelectorNew } from './EventGroupRaceCarnumSelectorNew';
import { Box, Button, Container } from '@mui/material';

export default function SessionDetails({
  setHeroState,
  isRaceHeroEvent,
  liftSelectedRunDetails,
  selectedRunDetails,
}) {
  return (
    <React.Fragment>
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            columnGap: '20px',
            paddingBottom: '20px',
          }}
        >
          <Button
            onClick={() => setHeroState(true)}
            variant="disabled"
            size="large"
          >
            RaceHero Event
          </Button>
          <Button
            onClick={() => setHeroState(false)}
            // variant="disabled"
            variant="outlined"
            size="large"
          >
            Other Event
          </Button>
        </Box>
        {!isRaceHeroEvent ? (
          <OtherEventForm />
        ) : (
          <React.Fragment>
            <EventGroupRaceCarnumSelectorNew
              selectedRunDetails={selectedRunDetails}
              liftSelectedRunDetails={liftSelectedRunDetails}
            />
            {selectedRunDetails?.racerId && (
              <RhRunTable data={selectedRunDetails} />
            )}
            {/* <pre>{JSON.stringify(selectedRunDetails, null, 2)}</pre> */}
          </React.Fragment>
        )}
      </Container>
    </React.Fragment>
  );
}
